import { Link, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useDemoStudyArea } from "hooks/studyAreaHooks";
import { JoyrideActivator } from "./JoyrideActivator";

export function JoyrideActivateButton() {
  const { data: demoStudyArea } = useDemoStudyArea();
  const { t } = useTranslation();

  function startJoyride() {
    if (demoStudyArea) {
      window.open(`/${demoStudyArea.uuid}?joyride=true`);
    }
  }
  return (
    <StyledLink color="primary" className="how-to-link" onClick={startJoyride}>
      {t("label.howDoIUseThisApplication")}
      <JoyrideActivator />
    </StyledLink>
  );
}

const StyledLink = styled(Link)`
  font-weight: 700;
  font-size: 14px;
  margin-right: ${({ theme }) => theme.spacing(2)};
`;
